<template>
  <div>
    <h1 class="title-form-ipt">Caracterización</h1>
    <div v-for="question in questions" :key="question.id">
      <div class="mt-4">
        <p class="ask-form-ipt">
          {{ question.number }}. {{ question.question }}
          <strong>*</strong>
        </p>
        <input-check-box
          :options="options"
          :id="question.id"
          :isBusy="isBusy"
          :isDetail="isDetail"
          :answer="question.answer"
          @answerQuestion="
            (value) =>
              $emit('answerQuestion', { ...value })
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
import InputCheckBox from "../formIpt/InputCheckBox.vue";

export default {
  props: {
    questions: {
      type: Array,
      default: () => [],
    },
    isBusy: {
      type: Boolean,
      default: false,
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    InputCheckBox,
  },
  data() {
    return {
      options: [
        { text: "Si", value: "1" },
        { text: "No", value: "0" },
      ],
    };
  },
  methods: {},
};
</script>

<style lang="scss">
.alert-warning-form-ipt {
  border: 1px solid #0075ff !important;
  border-radius: 4px !important;
  background-color: #e6f7ff !important;
  margin-bottom: 40px;
}

.hr-form-ipt {
  border-bottom: 1px solid #c9caff !important;
  margin: 16px 0 !important;
}

.hr-form-ipt2 {
  border-bottom: 1px solid #c9caff !important;
  margin: 16px 0 !important;
  width: 10% !important;
}

.title-form-ipt {
  font-family: Ubuntu !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  line-height: 28px !important;
  text-align: left !important;
  color: #5d5fef !important;
  text-transform: none !important;
}

.subtitle-form-ipt {
  font-family: Ubuntu !important;
  font-size: 16px !important;
  font-weight: 400 !important;
  line-height: 28px !important;
  text-align: left !important;
  color: #5d5fef !important;
  text-transform: none !important;
}

.ask-form-ipt {
  color: #37474f !important;
  font-family: Ubuntu !important;
  font-size: 16px !important;
  font-weight: 400 !important;
  line-height: 28px !important;
  text-align: left !important;
}

.ask-form-ipt strong {
  color: #da1414 !important;
}

.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border: solid 5px;
  // border-color: #007bff;
  background-color: #ffffff !important;
}

.custom-control-label {
  padding-left: 12px;
  font-family: Ubuntu !important;
  font-weight: 700 !important;
  // color: #37474F !important;
}

.custom-radio .custom-control-label::before {
  border-radius: 50%;
  width: 20px;
  height: 20px;
}

.custom-radio .custom-control-input {
  width: 2rem !important;
  height: 2rem !important;
}

.custom-radio
  .custom-control-input:disabled:checked
  ~ .custom-control-label::before {
  background-color: #ffffff;
}

.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  width: 0px;
  height: 0px;
}

.custom-control-inline {
  display: inline-flex;
  margin-right: 5rem !important;
  align-items: center !important;
}

.was-validated .custom-control-input:valid ~ .custom-control-label,
.custom-control-input.is-valid ~ .custom-control-label {
  color: #5d5fef !important;
}

.was-validated
  .custom-control-input:valid:checked
  ~ .custom-control-label::before,
.custom-control-input.is-valid:checked ~ .custom-control-label::before {
  border-color: #5d5fef;
  background-color: #5d5fef;
}

.was-validated .custom-control-input:valid ~ .custom-control-label::before,
.custom-control-input.is-valid ~ .custom-control-label::before {
  border-color: #5d5fef;
}
</style>
